<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import type { ManageAPI } from "~/manage-api/types";
  import type { StoresKey } from "~/stores";
  import { getStoresContext } from "~/stores";
  export let request_store_key: StoresKey;
  const dispatch = createEventDispatcher();
  const { scdata, stores , T} = getStoresContext(request_store_key);

  function search(event: Event) {
    const { target } = event;
    if (target) {
      const search_value = (target as HTMLButtonElement).value;
      dispatch("search", search_value);
    }
  }
  let fieldsOfBusiness: ManageAPI.Fob[] = [];
  let floors: ManageAPI.FloorBase[] = [];
  $: {
    if ($scdata && $stores) {
      fieldsOfBusiness = $scdata.fieldsOfBusiness.filter(
        (el) =>
          $stores.filter(
            (store) =>
              store.fieldOfBusinessId == el.id ||
              store.additionalFieldOfBusinessIds?.includes(el.id)
          ).length
      );
      floors = $scdata.floors.filter(
        (floor) =>
          $stores.filter((store) => Number(store.floor?.id) == Number(floor.id))
            .length
      );
    }
  }
  $: t = $T;

</script>

<div class="position-relative mb-5">
  <input
    class="form-control input-with-icon"
    name="Search for store"
    placeholder="{t`search`}"
    on:input={search}
  />
  <img src="/theme/citycon2023/images/Search.png" class="icon-in-input" alt="search" width="32">

</div>

<style>
  .input-with-icon {
    height: auto;
    padding: 0.625rem 0;
    border: none;
    border-bottom: 1px solid #000;
    border-radius: 0;
  }
  .icon-in-input {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
  }

  input.form-control {
    background: none;
  }
</style>
